const tabGroups = ['educationCenterInfo', 'department', 'lessonPlace'];

export default tabGroups;
